(() => {
  if (window.QLSCartRecencyV118Loaded) return;
  window.QLSCartRecencyV118Loaded = true;

  const STORAGE_KEY = 'qls_cart_item_recency_v1';
  const ROW_SELECTOR = 'tr.cart-item[data-item-key]';
  let scores = readScores();
  let scheduled = false;
  let sorting = false;
  let lastStamp = Date.now();

  function readScores() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function saveScores() {
    try {
      const entries = Object.entries(scores)
        .filter(([key, value]) => key && Number.isFinite(Number(value)))
        .sort((a, b) => Number(b[1]) - Number(a[1]))
        .slice(0, 120);
      scores = Object.fromEntries(entries);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
    } catch (error) {
      // Cart ordering remains functional for the current page if storage is unavailable.
    }
  }

  function nextStamp() {
    const now = Date.now();
    lastStamp = Math.max(now, lastStamp + 1);
    return lastStamp;
  }

  function touch(itemKey, quantity) {
    if (!itemKey) return;
    if (Number(quantity) === 0) {
      delete scores[itemKey];
    } else {
      scores[itemKey] = nextStamp();
    }
    saveScores();
    scheduleSort();
  }

  function groupRows(tbody) {
    const rows = Array.from(tbody.querySelectorAll(`:scope > ${ROW_SELECTOR}`));
    const groups = [];

    rows.forEach((row) => {
      if (row.classList.contains('cart-item--nested') && groups.length) {
        groups[groups.length - 1].rows.push(row);
        return;
      }

      groups.push({
        key: row.dataset.itemKey || '',
        protection: row.dataset.qlsShippingProtection === 'true',
        rows: [row]
      });
    });

    return groups;
  }

  function seedMissingScores(groups) {
    const missing = groups.filter((group) => group.key && !Number.isFinite(Number(scores[group.key])));
    if (!missing.length) return false;

    const base = nextStamp();
    missing.forEach((group, index) => {
      // Shopify currently renders newly added lines first. Preserve that order on
      // first sight, then let future adds/quantity changes explicitly take priority.
      scores[group.key] = base - index;
    });
    saveScores();
    return true;
  }

  function sortTbody(tbody) {
    const groups = groupRows(tbody);
    if (groups.length < 2) {
      seedMissingScores(groups);
      return;
    }

    seedMissingScores(groups);

    const sorted = groups.slice().sort((a, b) => {
      if (a.protection !== b.protection) return a.protection ? 1 : -1;
      return Number(scores[b.key] || 0) - Number(scores[a.key] || 0);
    });

    const currentKeys = groups.map((group) => group.key).join('|');
    const sortedKeys = sorted.map((group) => group.key).join('|');
    if (currentKeys === sortedKeys) return;

    const fragment = document.createDocumentFragment();
    sorted.forEach((group) => group.rows.forEach((row) => fragment.appendChild(row)));
    tbody.appendChild(fragment);
  }

  function sortAll() {
    scheduled = false;
    if (sorting) return;
    sorting = true;

    document.querySelectorAll('cart-items .cart-items > tbody').forEach(sortTbody);

    sorting = false;
  }

  function scheduleSort() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sortAll);
  }

  window.QLSCartRecency = {
    sortNow() {
      scheduled = false;
      sortAll();
    },
    schedule: scheduleSort
  };

  function scrollDrawerToLatest() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const content = drawer.querySelector('.drawer__content');
    if (content) content.scrollTop = 0;
    drawer.scrollTop = 0;
  }

  function mutationTouchesCart(mutation) {
    if (mutation.target?.closest?.('cart-items')) return true;
    return Array.from(mutation.addedNodes || []).some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches?.('cart-items, .cart-item') || node.querySelector?.('cart-items, .cart-item');
    });
  }

  document.addEventListener('qls:cart-item-touched', (event) => {
    const detail = event.detail || {};
    touch(detail.itemKey, detail.quantity);
    if (Number(detail.quantity) > 0) {
      window.setTimeout(scrollDrawerToLatest, detail.source === 'add' ? 520 : 180);
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('#cart-icon')) return;
    window.setTimeout(() => {
      scheduleSort();
      scrollDrawerToLatest();
    }, 120);
  });


  document.addEventListener('dispatch:cart-drawer:open', scheduleSort);
  document.addEventListener('dispatch:cart-drawer:refresh', scheduleSort);
  document.addEventListener('shopify:section:load', scheduleSort);
  document.addEventListener('on:bfcache:load-restore', scheduleSort);

  const observer = new MutationObserver((mutations) => {
    if (sorting) return;
    if (mutations.some(mutationTouchesCart)) scheduleSort();
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    sortAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
